import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  flightDirection: {
    [down("xs")]: {
      "& p": {
        fontSize: "14px",
      },
    },
  },
}));

const FlightDirection = ({ time, date, location, airportAbbr }) => {
  const classes = useStyles();
  return (
    <Box className={classes.flightDirection}>
      <Typography variant="body2" display="inline">{`${time}  `}</Typography>
      <Typography
        variant="body1"
        display="inline"
      >{`${date} — ${location}, ${airportAbbr}`}</Typography>
    </Box>
  );
};

export default FlightDirection;
